import * as Actions from './actions'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ...Actions
  }
}